import { render } from "./ClockCircleIcon.vue?vue&type=template&id=6ff23e38"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__